import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Index from '@/components/Index'
import Post from '@/components/Post'
import Page from '@/components/Page'
import Login from '@/components/Login'
import Edit from '@/components/Edit'
import EditOption from '@/components/EditOption'
import EditType from '@/components/EditType'
import EditTag from '@/components/EditTag'
import EditPosts from '@/components/EditPosts'
import EditPost from '@/components/EditPost'
import EditPages from '@/components/EditPages'
import EditPage from '@/components/EditPage'
import EditComments from '@/components/EditComments'
import EditUsers from '@/components/EditUsers'
import NotFound from '@/components/NotFound'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/type/:typeSlug',
    name: 'Index',
    component: Index
  },
  {
    path: '/tag/:tagSlug',
    name: 'Index',
    component: Index
  },
  {
    path: '/post/:id',
    name: 'Post',
    component: Post
  },
  {
    path: '/edit',
    name: 'Edit',
    component: Edit
  },
  {
    path: '/edit/option',
    name: 'EditOption',
    component: EditOption
  },
  {
    path: '/edit/type',
    name: 'EditType',
    component: EditType
  },
  {
    path: '/edit/type/:slug',
    name: 'EditType',
    component: EditType
  },
  {
    path: '/edit/tag',
    name: 'EditTag',
    component: EditTag
  },
  {
    path: '/edit/tag/:slug',
    name: 'EditTag',
    component: EditTag
  },
  {
    path: '/edit/posts',
    name: 'EditPosts',
    component: EditPosts
  },
  {
    path: '/edit/post',
    name: 'EditPost',
    component: EditPost
  },
  {
    path: '/edit/post/:id',
    name: 'EditPost',
    component: EditPost
  },
  {
    path: '/edit/pages',
    name: 'EditPages',
    component: EditPages
  },
  {
    path: '/edit/page',
    name: 'EditPage',
    component: EditPage
  },
  {
    path: '/edit/page/:slug',
    name: 'EditPage',
    component: EditPage
  },
  {
    path: '/edit/comments',
    name: 'EditComments',
    component: EditComments
  },
  {
    path: '/edit/users',
    name: 'EditUsers',
    component: EditUsers
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/:slug',
    name: 'Page',
    component: Page
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = new Router({
  mode:'history',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = store.getters.option.title
  document.querySelector('meta[name="description"]').setAttribute('content', store.getters.option.description)
  document.querySelector('meta[name="keywords"]').setAttribute('content', store.getters.option.keywords)
  if(to.fullPath === '/login') {
    if(from.path !== '/login') {
      next(`/login?jump=${encodeURIComponent(from.fullPath)}`)
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js